// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"42e45e68","65":"f500774c","453":"da27096b"}[chunkId] + ".chunk.js";
};